import PropTypes from 'prop-types';

export const UserProductModel = {
    id: PropTypes.string,
    name: PropTypes.string,
    displayName: PropTypes.string,
    icon: PropTypes.string
};

export const UserMenuModel = {
    fullName: PropTypes.string,
    initials: PropTypes.string,
    customerName: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.shape(UserProductModel))
};
